<template>
  <div
    :id="'view-'+name"
    class="content-wrapper mask"
    ref="mask"
    @touchstart="handleClick"
    @mousedown="handleClick"
  >
    <background-video-player
      :ref="videoPlayerId"
      :key="videoPlayerId"
      :videos="videoSource1"
      :videoPlayerId="videoPlayerId"
      :hoverableId="hoverableId"
      @playtime-event="handlePlayTimeUpdate"
    />
    <hoverable-svg :hoverableItems="hoverable" :hoverableId="hoverableId" :ref="hoverableId"/>
    <div class="mask_overlay" ref="maskOverlay" id="maskOverlay">
      <background-video-player
        style="height:1080px !important; width:1920px !important"
        :ref="videoPlayerIdMaskOverlay"
        :key="videoPlayerIdMaskOverlay"
        :videos="videoSource2"
        :videoPlayerId="videoPlayerIdMaskOverlay"
        :hoverableId="hoverableOverlayId"        
      />
      <hoverable-svg
        :hoverableItems="hoverableOverlay"
        :hoverableId="hoverableOverlayId"
        :ref="hoverableOverlayId"
      />
    </div>

    <div ref="backdrop" class="backdrop background"></div>
    <div id="dragme" ref="mask_handle" class="mask_handle">
      <svg id="splitbar" width="200px" height="1080px" xmlns="http://www.w3.org/2000/svg">
        <line x1="100" y1="0" x2="100" y2="1080" style="stroke:rgb(224, 178, 80);stroke-width:10"></line>
        <circle
          cx="100"
          cy="540"
          r="42"
          stroke="rgb(225, 179, 81)"
          stroke-width="10"
          fill="rgb(224, 178, 80)"
        ></circle>

        <!-- outter circle -->
        <!-- <circle cx="100" cy="540" r="95" stroke="rgb(224, 178, 80)" stroke-width="5" fill="transparent"/> -->
        <path
          id="outter"
          style="stroke: rgb(224, 178, 80); stroke-dasharray:820; stroke-dashoffset:820; stroke-width:5;
         fill:transparent"
          d="M100,540 m0,-95 
         a 95,95 0 0,1 0,190 
         a 95,95 0 0,1 0,-190"
        >
          <animate attributeName="stroke-dashoffset" dur="6s" to="-820" repeatCount="indefinite"></animate>
        </path>
        <g fill="white" transform="translate(65 527.5)">
          <polygon points="10,12.5 25,0 25,25" fill="white" stroke="white"></polygon>
          <polygon
            points="10,12.5 25,0 25,25"
            fill="white"
            stroke="white"
            transform="rotate(180, 12.5, 12.5) translate(-40 0)"
          ></polygon>
        </g>
      </svg>
      <div class="handleMsg">Drag this
        <span class="handleMsgBold">handle</span> to explore the
        <br>different upgrade stages at Tuxpan
      </div>
    </div>
    <cf-button
      :width=280
      :key="'view-'+name+'-continue'"
      :id="'view-'+name+'-continue'"
      class="btn-continue"
      @click.native="handleClick"
      :content="'See results'"
      animation
      :to="{name: 'Result'}"
    />
  </div>
</template>

<script>
import { EventBus } from "@/assets/js/event-bus";
import HoverableSvg from "@/components/Hoverable-SVG";
import BackgroundVideoPlayer from "@/components/Background-Video-Player";
import BaseViewPage from "@/views/BaseViewPage";
import HoverableImage from "@/components/Hoverable-Image";
import CfButton from "@/components/CF-Button";
import Draggable from "gsap/Draggable";
import { defaultCoreCipherList } from 'constants';

export default {
  // extends: BaseViewPage,
  components: {
    BackgroundVideoPlayer,
    CfButton,
    HoverableSvg,
    HoverableImage
  },
  computed: {   
    hoverableOverlayId() {
      return `${this.name}-hoverable-stage-1`;
    },
    videoPlayerIdMaskOverlay() {
      return `${this.name}-videoPlayer-stage-1`;
    }
  },
  data() {
    const name = "Compare";
    const configJSON = window.configMgr.views[name].data;
    configJSON.name = name;
    configJSON.played = false;
    configJSON.hoverableId = `${name}-hoverable-stage2-3`;
    configJSON.videoPlayerId = `${name}-videoPlayer-stage2-3`;
    configJSON.videoPlayerBackgroundId = `${name}-videoPlayerBackground`;

    return {
      ...configJSON,
      activated: true,
      navBtnImg: {
        imageSrc: "static/images/home/Btn1.png"
      },
      hoverable: [
        {
          debug: false,
          circle : { cx:1838, cy:76, r:20},
          gallery: {
            width: 1226,
            images: [
              {
                src: "./static/images/stage2.png"
              }
            ]
          }
        }
      ],
      hoverableOverlay: [
        {
          debug: false,
          circle : { cx:670, cy:942, r:20},
          gallery: {
            width: 1226,
            images: [
              {
                src: "./static/images/stage1.png"
              }
            ]
          }
        }
      ]
    };
  },
  beforeRouteEnter(to, from, next) {     
    window.preloader.preloadForView(to.name, next);
  },
  activated() {
    this.activated = true
    // update back link to the defined value in config.json
    if (typeof this.backLink !== 'undefined') {
      this.$emit('require-back-link', this.backLink);
    }

    // console.log(`${this.name} sub is being activated`);
    // EventBus.$emit('show-logo-event', false);
    this.init = true;
    this.$refs[this.videoPlayerId].readyToGo();
    this.$refs[this.videoPlayerIdMaskOverlay].readyToGo();

    this.mask = this.$refs["mask"];
    this.maskOverlay = this.$refs["maskOverlay"];
    this.maskHandle = this.$refs["mask_handle"];
    this.played = false;
    var dragger = Draggable.create("#dragme", {
      zIndexBoost : false,
      type: "left",
      liveSnap: {
        left: function(value) {
          const scaleAmt = appDashScalingFactor; //Note for the dragging to work this scale value needs to be updated when your browser window size changes.
          const inverseScale = 1 / scaleAmt;
          const deltaX = value - this.startX;
          const scaledX = deltaX * inverseScale;
          const maskOverlay = document.getElementById("maskOverlay");
          const dragme = document.getElementById("dragme");
          // debugger
          let updatedX = this.startX + scaledX; // in pixel
          if (updatedX < -40) {
            updatedX = -40;
          } else if (updatedX > 1760) {
            updatedX = 1760;
          }
          // debugger
          // console.log(`delta:${deltaX}; value:${value}; updatedX:${updatedX}`);
          return updatedX;
        }
      },
      onDrag: function() {
        // debugger
        const dragme = document.getElementById("dragme");

        // adjust the width of split handle bar
        const handleLeftPos = parseInt(dragme.style.left.replace("px", ""));
        const adjustedCenter = handleLeftPos + 100; // 100 is the total width of split bar /2
        maskOverlay.style.width = adjustedCenter + "px";
        // console.log(`handle width:${maskOverlay.style.width}`);
      }
    });

    // initialize page
    // Set the middle point of the handlebar with the overlay video
    // 860 is the midpoint minus half the handle bar and half the handle bar is on one video
    // and the other half is on another one.
    // Can tweet in the handle bar and width of overlay
    // this.maskHandle.style.left = "860px"
    // this.maskOverlay.style.width = "960px"
    TweenMax.to(".backdrop", 0, { autoAlpha: 0.75 });
    TweenMax.to(".handleMsg, #outter", 0, { autoAlpha: 1 });
    TweenMax.fromTo(
      `#view-${this.name} .mask_handle`,
      0.5,
      { autoAlpha: 0, left: 1500 },
      { ease: "Expo.easeOut", zIndex:15, left: 860, autoAlpha: 1, delay: 0.25 }
    );
    TweenMax.fromTo(
      `#view-${this.name} .mask_overlay`,
      2,
      { width: 1600 },
      { ease: "Expo.easeOut", width: 960, delay: 0.5 }
    );
    TweenMax.fromTo(`#view-${this.name} .btn-continue`, 2, { right: 20, opacity: 0},
                         { right: 80, ease: 'Expo.easeOut', opacity: 1, delay: 1 });

  },
  deactivated() {
    this.$refs[this.videoPlayerId].enableHoverableWhilePlaying(false);
    this.$refs[this.videoPlayerIdMaskOverlay].enableHoverableWhilePlaying(false);
    TweenMax.to( `#view-${this.name} .mask_handle`, 0, { zIndex:0 });
  },
  methods: {
    handlePlayTimeUpdate(videoId, duration, event) {
      const trackingDelayForInitialActivateDueToRouteTackingDelay = this.activated? 1500: 0
      this.activated = false    
      const vid1 = this.videoSource1[0].video.replace(/^.*[\\\/]/, '')
      const vid2 = this.videoSource2[0].video.replace(/^.*[\\\/]/, '')
      // handle looping video, to send ended event prior to play event      
      // Kludge: a delay is put in because the route change also has a delay for adobe analytic
      // if the delay is not here, then the pageData may get updated after the video event is fired with the old page data
      if (event === "play"){
        if (this.played) {
          setTimeout(()=>{this.callVideoAnalytic(vid1, vid2, duration, "ended")}, trackingDelayForInitialActivateDueToRouteTackingDelay)
        }
        this.played = true
      }
      setTimeout(()=>{this.callVideoAnalytic(vid1, vid2, duration, event)}, trackingDelayForInitialActivateDueToRouteTackingDelay)
    },
    handleClick() {
      //console.log('i clicked')
      if (this.init) {
        TweenMax.to(".backdrop, .handleMsg, #outter", 0.25, {
          ease: Expo.easeIn,
          autoAlpha: 0
        });
      }
      this.init = false;
    },
    convertSeconds: function (sec) {
        var time = Math.floor(sec / 60) + ':';
        var sec = Math.floor(sec % 60);
        time += (sec < 10 ? "0" : "") + sec;
        return time;
    },
    
    callVideoAnalytic(videoName1, videoName2, videoDuration, event) {
      // src="//assets.adobedtm.com/1fa38a1ae2d9f941f2a1d71bb8bfe23bc7257303/satelliteLib-af2ee0495bfae1c91fe1e360995ec68a2fa50eae-staging.js"
      if(window._satellite){    
        window.GEAnalytics = window.GEAnalytics || {}
        window.GEAnalytics.videoData = window.GEAnalytics.videoData || {}

        window.GEAnalytics.videoData.videoName = videoName1
        window.GEAnalytics.videoData.eventName = event
        window.GEAnalytics.videoData.videoID = videoName1
        window.GEAnalytics.videoData.videoDuration = this.convertSeconds(videoDuration)
        // console.log(`${ window.GEAnalytics.videoData.videoName} ${window.GEAnalytics.videoData.eventName}`)
        if( window.GEAnalytics.pageData.pageName === 'time-lapse'){
          _satellite.track("video track")
        }

        window.GEAnalytics.videoData.videoName = videoName2
        window.GEAnalytics.videoData.videoID = videoName2
        if( window.GEAnalytics.pageData.pageName === 'time-lapse'){
          _satellite.track("video track")
        }
      } 
    }
  }
};
</script>

<style lang="css" scoped>
/*@import "./resources/assets/sass/variables";*/
/* .mask {
  position: relative !important;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  text-align: left;
} */

.mask_overlay {
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  width: 0px;
  height: 100%;
  overflow: hidden;
}

.mask_handle {
  z-index: 5;
  position: absolute;
  top: 0px;
  left: 0px;
  cursor: pointer;
  bottom: 0;
  height: 100%;
  border: none;
  background-color: transparent;
  width: 5px;
  /* padding-left: 10px;
  padding-right: 10px; */
  text-align: center;
  /* background: linear-gradient(
    to right,
    transparent 0%,
    transparent calc(50% - 3px),
    cyan calc(50% - 3px),
    cyan calc(50% + 2px),
    transparent calc(50% + 2px),
    transparent 100%
  ); */
}

/* .mask_handle span {
  background-color: #000000;
  color: #ffffff;
} */
.mask_handle span::before {
  margin: 0 0 0 0;
}

svg#splitbar {
  position: relative;
  /* background: lightgray; */
}

.btn-continue {
  z-index: 5;
  position: absolute;
  top: 910px;
}

.handleMsg {
  color: rgb(224, 178, 80);
  position: absolute;
  width: 900px;
  text-align: left;
  top: 480px;
  left: 222px;
  font-size: 40px;
}

.handleMsgBold {
  color: rgb(225, 179, 81);
  font-weight: bolder;
}

.backdrop {
  background: black;
  z-index: 10;
 
}
</style>



// WEBPACK FOOTER //
// compare.vue?6d0fe510